import { Router, UrlTree } from '@angular/router';
import { AppConfig } from '@mkp/shared/util-app-config';

const ERROR_ROUTES = {
  403: AppConfig.routes.error403,
  404: AppConfig.routes.error404,
  500: AppConfig.routes.error500,
} as const;

type ErrorStatus = keyof typeof ERROR_ROUTES;

const isErrorStatus = (status: number): status is ErrorStatus => status in ERROR_ROUTES;

/**
 * The error page a guard redirects to, keyed by the status it is standing in for. A status
 * with no page of its own falls back to 500, which is what an unrecognised one amounts to:
 * the guard cannot tell the user why, so it says as much.
 */
export const errorUrlTree = (router: Router, status = 500): UrlTree =>
  router.parseUrl(ERROR_ROUTES[isErrorStatus(status) ? status : 500]);
